import { JSMOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { CreateAWorkspaceText } from '../components/create-a-workspace-heading';
import { Headings } from '../components/headings';
import { WorkspacesAreWhereText } from '../components/sub-heading';

const NewUserContent = () => {
	return (
		<>
			<Headings main={<CreateAWorkspaceText />} sub={<WorkspacesAreWhereText />} />
			<SiteActivation />
		</>
	);
};

export const NewUser = () => (
	<JSMOverlayTemplate size="sm">
		<NewUserContent />
	</JSMOverlayTemplate>
);
